import { FilterPill } from '#components/atoms/pill/filter-pill/FilterPill.tsx';

type Props = {
  onClick: () => void;
  targetId: string;
  className?: string;
};

export function LogFilterPill({ onClick, targetId, className }: Props) {
  return <FilterPill className={className} label={targetId} onClick={onClick} />;
}
